import { createSlice } from "@reduxjs/toolkit";

const tournamentSlice = createSlice({
    name:'tournament',
    initialState:{
        tournament:[]
    },
    reducers: {
        addTournament : (state,action) => {
            // console.log("test ",action)
            //state.push(action.payload)
            state.tournament = [...state.tournament,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addTournament } = tournamentSlice.actions;
export default tournamentSlice.reducer;